// extracted by mini-css-extract-plugin
export default {"Emojify":"bbe_a bhe_g"};